<template>
  <div class="wrap">
    <TabPlaceholder
        :caption="$t('home.not_found_page.pageNotFound')"
    />
    <a
      class="home-link"
      @click="$router.push({ name: 'home'})"
    >
      {{ $t('home.not_found_page.showModels') }}
    </a>
  </div>
</template>

<script>
import TabPlaceholder from '@/components/common/TabPlaceholder'

export default {
  components: {
    TabPlaceholder
  }
}
</script>

<style lang="scss" scoped>
  .wrap {
    display: flex;
    position: relative;
    height: 100%;

    .home-link {
      position: absolute;
      top: calc(50% + 110px);
      left: 50%;
      transform: translate(-50%, -50%);
      color: $or-blue;

      &:hover {
        cursor: pointer;
      }
    }
  }
</style>
